<template>
  <div class="container">
    <div class="content">
      <h2>Seu atendimento foi finalizado!</h2>
      <!-- <p>Por favor, dirija-se à recepção</p> -->
      <p>{{ msg }}</p>
      <img :src="'/static/img/checkmark.gif'" alt="">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    customer: Object,
    professional: Object,
    returns: Array,
  },
  data() {
    return {
      msg: '',
      lang: 'pt-BR',
      returnTimer: null,
    }
  },
  mounted() {
    const professionalMessage = this.professional && this.professional.totenmessage && this.professional.totenmessage.message;
    this.msg = professionalMessage
      ? 'Seu atendimento foi finalizado. Para confirmar seu agendamento, ' + professionalMessage
      : 'Seu atendimento foi finalizado! Para confirmar seu agendamento, aguarde ser chamado no sistema de voz.';

    this.returnTimer = setTimeout(() => {
      this.$emit('clearCustomer');
      this.$emit('buttonClicked', 'StartPage');
    }, 6000);
    this.speak(this.msg);
  },
  beforeDestroy() {
    if (this.returnTimer) clearTimeout(this.returnTimer);
  },
  methods: {
    speak(msg) {
      if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) return;
      try {
        window.speechSynthesis.speak(new window.SpeechSynthesisUtterance(msg));
      } catch (err) {
        console.error('Não foi possível reproduzir a mensagem final:', err);
      }
    }
  }
}
</script>
<style scoped>
.container {
  position: absolute;
  top: 90%;
  left: 25%;
  width: 100%;
  margin: -24% 0 0 -25%;
}
.content {
  text-align: center;
}
h2 {
  font-size: 60px;
  color: #fff;
  text-align: center;
}
p {
  font-size: 36px;
  color: #fff;
  font-family: 'Source Sans Light';
  font-weight: bold;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/FinishTicket.vue